import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/lib/queryClient';
import { registerServiceWorker } from '@/lib/swRegister';
import { Capacitor } from '@capacitor/core';
import { registerDeepLinkListener } from '@/lib/native';

// Suppress console.log in production — but NOT on native (Capacitor):
// Logcat/Xcode logs are essential to debug deep links and native plugins.
if (process.env.NODE_ENV === 'production' && !Capacitor.isNativePlatform()) {
  console.log = () => {};
  console.debug = () => {};
}

// Explicit native init at the real entrypoint — do NOT rely on module
// side-effects: the deep link listener MUST be registered before any
// Google login can happen.
console.log('[NativeInit] platform', Capacitor.getPlatform());
if (Capacitor.isNativePlatform()) {
  console.log('[NativeInit] native platform detected');
  registerDeepLinkListener();
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Register service worker for offline cache (production only)
registerServiceWorker();

// Hide the NATIVE Capacitor splash screen (iOS LaunchScreen / Android
// drawable) as soon as the app is ready. Safe on plain web — when
// `window.Capacitor` is missing this is a no-op.
function hideNativeSplash() {
  try {
    if (window.Capacitor && window.Capacitor.Plugins && window.Capacitor.Plugins.SplashScreen) {
      window.Capacitor.Plugins.SplashScreen.hide();
    }
  } catch (_) { /* noop */ }
}
window.addEventListener('load', () => setTimeout(hideNativeSplash, 2000));
setTimeout(hideNativeSplash, 7000);  // safety net
